<template>
	<WorkIt>
		<Intro
			title="iOS & Android App"
			subtitle="GoA2B">
			<p>GoA2B set out to be the “Kayak of ridesharing”. The native app compared price and time estimates of all local ridesharing services in real time, saving users an average of 1.5 minutes. After two months in the app stores, iOS had about 36,000 downloads, and Android had over 77,000, all with an average 4-star rating.</p>
		</Intro>

		<div class="px14">
			<img class="m-auto mb-20 hidden sm:block" src="/img/ios-android-main-min.png" srcset="/img/ios-android-main@2x-min.png 2x" alt="" />
			<img class="m-auto mb-20 hidden sm:block" src="/img/goa2b-branding-min.png" srcset="/img/goa2b-branding@2x-min.png 2x" alt="" />

			<img class="m-auto sm:hidden" src="/img/mobile-ss-min.png" srcset="/img/mobile-ss@2x-min.png 2x" alt="" />
		</div>

		<FooterNav prev="/work/dashboard-redesign" next="/work/ellie-mae-blocks"></FooterNav>
	</WorkIt>
</template>

<script>
import Intro from '@/components/Intro.vue';
import WorkIt from '@/components/WorkIt.vue';
import FooterNav from '@/components/FooterNav.vue';

import { mapMutations } from 'vuex';

export default {
	components: {
		Intro,
		WorkIt,
		FooterNav
	},
	methods: {
		...mapMutations([
			'APP_CLASS'
		])
	},
	created: function() {
		this.APP_CLASS('page-work work-detail ios-android-app');
	}
}
</script>